import Service from "../Service";

const resource = "sprint/";

export default {
    /**
     * Guardar sprint (crear o actualizar)
     */
    save(cmp, requestID) {
        return Service.post(resource + "save", cmp, {
            params: { requestID: requestID },
        });
    },

    /**
     * Obtener lista paginada de sprints
     */
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },

    /**
     * Obtener lista de sprints con filtros
     */
    list(filters, requestID) {
        return Service.post(resource + "list", filters, {
            params: { requestID: requestID },
        });
    },

    /**
     * Activar un sprint
     */
    activate(obj, requestID) {
        return Service.post(resource + "activate", obj, {
            params: { requestID: requestID },
        });
    },

    /**
     * Completar un sprint
     */
    complete(obj, requestID) {
        return Service.post(resource + "complete", obj, {
            params: { requestID: requestID },
        });
    },

    /**
     * Obtener todos los sprints sin paginación
     */
    getAllSprints(obj,requestID) {
        
        return Service.post(resource + "list", obj, {
            params: { requestID: requestID },
        });
    },
        // Asignar tarea a un sprint
    assignTaskToSprint(obj, requestID) {        
        return Service.post(resource + "assignTask", obj, {
            params: { requestID: requestID },
        });
    },

    // Remover tarea de un sprint
    removeTaskFromSprint(obj, requestID) {
        return Service.post(resource + "removeTaskFromSprint", obj, {
            params: { requestID: requestID },
        });
    },
    getTasksBySprint(obj, requestID) {
        return Service.post(resource + "getTasksBySprint", obj, {
            params: { requestID: requestID },
        });
    },
    getBoardColumns(requestID) {
        return Service.post(resource + "getBoardColumns", {}, {
            params: { requestID: requestID },
        });
    }
};
